<div class="book-list">
    <div class="button regular close">
        <span class="icon">×</span>
    </div>
    <div class="search">
        <app-input-form  
            [form]="form"
            id="book"
            [required]="true" 
            (keyup)="searchBooks()"
        ></app-input-form>
    </div>
    <div *ngIf="loading; else display" class="loading-container">
        <app-spinner></app-spinner>
    </div>
    <ng-template #display>
        <ul>
            <li *ngFor="let book of filteredBooks" (click)="selectBook(book)">
                <div class="image">
                    <img src="{{book.amazonImageUrl || defaultImageUrl}}" alt="{{book.title}}" />
                </div>
                <h4 class="title strong2">{{book.title}}</h4>
                <div class="author">by {{book.author}}</div>
            </li>
        </ul>
    </ng-template> 
</div>
